import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import tk from '../../assets/images/game/shade.png'
import './index.scss'

export default function Game() {
    const [progress, setProgress] = useState(0);
    const startTimeRef = useRef(null);

    const [show, setShow] = useState()
    const navigate = useNavigate()
    useEffect(() => {
        const animate = (timestamp) => {
            if (!startTimeRef.current) startTimeRef.current = timestamp;
            const elapsed = timestamp - startTimeRef.current;
            const progress = Math.min(elapsed / 2000, 1) * 100;
            setProgress(progress);

            if (elapsed < 2000) {
                requestAnimationFrame(animate);
            } else {
                setShow(true)
            }
        };
        setTimeout(() => {
            requestAnimationFrame(animate);
        }, 1100);
    }, []);

    return (
        <div className='game-page'>
            <div className="title1 animate__animated  animate__bounceIn  "></div>
            <div className="title2 animate__animated   animate__zoomInDown "></div>
            <div className='progress animate__animated  '>
                {Math.round(progress)}%
            </div>
            {show && <div className="shade animate__animated  animate__fadeIn animate__fast">
                <img src={tk} alt="" srcset="" style={{ minWidth: '39.875rem', minHeight: '25.1875rem' }} />
                <div className="btn" onClick={() => {
                    navigate('/Game/Play')
                }}></div>
            </div>}
        </div>
    )
}
